import { FC } from 'react'
import styled from 'styled-components'

import iconLogo from './bluesite-hub-icon-black.png'

interface LogoShortBluesiteProps {
  style?: React.CSSProperties
}

const Wrapper = styled.div`
  height: 34px;
  width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
`

const LogoShortBluesite: FC<LogoShortBluesiteProps> = ({ style }) => (
  <Wrapper style={style}>
    <Image src={iconLogo} alt="Bluesite HR Hub" />
  </Wrapper>
)

export default LogoShortBluesite
